import React, { useState } from 'react';
import { supabase } from '../supabase';
import LogoMark from './LogoMark';

function LoginModal({ onClose, colors, fonts }) {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);
  const [error, setError] = useState(null);

  const handleSubmit = async () => {
    if (!email) return;
    setLoading(true);
    setError(null);
    
    const { error } = await supabase.auth.signInWithOtp({
      email,
      options: {
        emailRedirectTo: window.location.origin
      }
    });

    if (error) {
      setError(error.message);
      setLoading(false);
    } else {
      setSent(true);
      setLoading(false);
    }
  };

  return (
    <div
      style={{
        position: "fixed",
        top: 0, left: 0, right: 0, bottom: 0,
        background: "rgba(0,0,0,0.7)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        zIndex: 10000,
        padding: "2rem"
      }}
      onClick={onClose}
    >
      <div
        onClick={(e) => e.stopPropagation()}
        style={{
          background: "#fff",
          borderRadius: "20px",
          maxWidth: "440px",
          width: "100%",
          padding: "3rem",
          fontFamily: fonts.body,
          position: "relative",
          textAlign: "center"
        }}
      >
        {/* Close X */}
        <button
          onClick={onClose}
          style={{
            position: "absolute",
            top: "1.5rem",
            right: "1.5rem",
            background: "transparent",
            border: "none",
            fontSize: "1.5rem",
            color: colors.brownGray,
            cursor: "pointer"
          }}
        >
          ×
        </button>

        {/* Icon */}
        <div style={{ marginBottom: "1rem" }}>
          <LogoMark width={200} height={80} />
        </div>

        {!sent ? (
          <>
            <h2 style={{
              fontSize: "1.8rem",
              fontFamily: fonts.display,
              color: colors.charcoal,
              marginBottom: "0.5rem"
            }}>
              Welcome Back!
            </h2>
            <p style={{
              color: colors.darkGray,
              marginBottom: "2rem",
              lineHeight: "1.6"
            }}>
              Enter your email and we'll send you a magic link to sign in instantly — no password needed!
            </p>

            <input
              type="email"
              placeholder="your@email.com"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              onKeyDown={(e) => e.key === "Enter" && handleSubmit()}
              style={{
                width: "100%",
                padding: "0.875rem 1rem",
                border: `2px solid ${colors.borderGreige}`,
                borderRadius: "10px",
                fontSize: "1rem",
                fontFamily: fonts.body,
                outline: "none",
                marginBottom: "1rem",
                boxSizing: "border-box"
              }}
            />

            {error && (
              <p style={{
                color: colors.dustyRust,
                fontSize: "0.9rem",
                marginBottom: "1rem"
              }}>
                {error}
              </p>
            )}

            <button
              onClick={handleSubmit}
              disabled={loading || !email}
              style={{
                width: "100%",
                padding: "0.875rem",
                background: loading || !email ? colors.borderGreige : colors.sageGreen,
                color: "#fff",
                border: "none",
                borderRadius: "10px",
                fontSize: "1rem",
                fontWeight: "600",
                cursor: loading || !email ? "not-allowed" : "pointer",
                fontFamily: fonts.body,
                transition: "all 0.2s"
              }}
            >
              {loading ? "Sending..." : "Send Magic Link ✨"}
            </button>

            <p style={{
              color: colors.brownGray,
              fontSize: "0.85rem",
              marginTop: "1.5rem"
            }}>
              New here? Just enter your email — we'll create your account automatically!
            </p>
          </>
        ) : (
          <>
            <div style={{ fontSize: "3rem", marginBottom: "1rem" }}>📬</div>
            <h2 style={{
              fontSize: "1.8rem",
              fontFamily: fonts.display,
              color: colors.charcoal,
              marginBottom: "0.5rem"
            }}>
              Check Your Email!
            </h2>
            <p style={{
              color: colors.darkGray,
              lineHeight: "1.6",
              marginBottom: "2rem"
            }}>
              We sent a magic link to <strong>{email}</strong>. Click the link in your email to sign in!
            </p>
            <button
              onClick={onClose}
              style={{
                width: "100%",
                padding: "0.875rem",
                background: colors.sageGreen,
                color: "#fff",
                border: "none",
                borderRadius: "10px",
                fontSize: "1rem",
                fontWeight: "600",
                cursor: "pointer",
                fontFamily: fonts.body
              }}
            >
              Got it!
            </button>
          </>
        )}
      </div>
    </div>
  );
}

// ========================================
// USERNAME SETUP MODAL
// ========================================

export default LoginModal;
